import request from "superagent";
import qs from "qs";

import { getAuthHeader } from "src/utils/superagent";

interface GetExclusionRequest {
  facilityId: string;
  agentId?: string;
  agentIds?: string[];
  pageSize?: number;
}

interface CreateExclusionRequest {
  actionBy: string;
  notes: string;
  reasons: string[];
  facilityId: string;
  agentId: string;
  adminId?: string;
  shiftId?: string;
  shiftReviewId?: string;
  severity?: {
    question: string;
    response: string;
  };
}

export type ExclusionForList = {
  createdAt: string;
  agent: {
    userId: string;
    name: string;
  };
  notes: string;
  reason: string;
  _id: string;
  actionBy: "AGENT" | "FACILITY";
};

export type ExclusionForView = {
  actionBy: string;
  agent: string;
  archived: boolean;
  createdAt: string;
  excludedBy: string;
  facility: string;
  notes: string;
  reason: string;
  shiftId: string;
  shiftReviewId?: string | null;
  updatedAt: string;
  _id: string;
};

export const fetchExclusion = async (
  requestBody: GetExclusionRequest
): Promise<ExclusionForList[]> => {
  const response = await request
    .get(`${global.api}/exclusion`)
    .set(await getAuthHeader())
    .query(qs.stringify(requestBody, { arrayFormat: "brackets" }));
  return response.body;
};

export const createExclusion = async (
  requestBody: CreateExclusionRequest
): Promise<ExclusionForView> => {
  const response = await request
    .post(`${global.api}/exclusion`)
    .set(await getAuthHeader())
    .send(requestBody);
  return response.body;
};

export const deleteExclusion = async (exclusionId: string, deleteNote?: string) => {
  const response = await request
    .delete(`${global.api}/exclusion/${exclusionId}`)
    .set(await getAuthHeader())
    .send({ deleteNote });
  return response.body;
};
